import { MailIcon, PhoneIcon } from 'lucide-react'

import {
  AGENCY_EMAIL,
  AGENCY_LOCATION_LABEL,
  AGENCY_OPENING_HOURS_LABEL,
  AGENCY_PHONE,
  REUNION_ADDRESS,
  REUNION_EMAIL,
  REUNION_OPENING_HOURS_LABEL,
  REUNION_PHONE,
} from '@/lib/constants/agency'

import { CloudyContactCard, CloudyCopiableContactCard } from './cloudy-copiable-contact-card'

interface PaymentConfirmationSharedScreenProps {
  departureAirportCode?: string
}

export function PaymentConfirmationSharedScreen({
  departureAirportCode,
}: PaymentConfirmationSharedScreenProps) {
  const isReunion = departureAirportCode === 'RUN'

  const phone = isReunion ? REUNION_PHONE : AGENCY_PHONE
  const email = isReunion ? REUNION_EMAIL : AGENCY_EMAIL
  const locationLabel = isReunion
    ? `Massilia Voyages agence La Réunion : ${REUNION_ADDRESS}`
    : AGENCY_LOCATION_LABEL
  const openingHours = isReunion ? REUNION_OPENING_HOURS_LABEL : AGENCY_OPENING_HOURS_LABEL

  return (
    <div className="flex w-full flex-col gap-10 pb-7">
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <CloudyCopiableContactCard
          icon={PhoneIcon}
          label="Téléphone"
          title="Nous appeler !"
          value={phone}
        />
        <CloudyCopiableContactCard
          icon={MailIcon}
          label="Adresse email"
          title="Par email"
          value={email}
        />
        <CloudyContactCard title="Appel Whatsapp">
          <div className="flex w-full cursor-not-allowed items-center gap-3 rounded-lg opacity-80">
            <img alt="Whatsapp" className="h-8 w-8" src="/icons/whatsapp.svg" />
            <p className="flex flex-1 text-sm font-medium text-white">Nous appeler via Whatsapp</p>
            <span className="rounded-full bg-white/20 px-2 py-1 text-xs font-semibold text-white">
              Bientôt disponible
            </span>
          </div>
        </CloudyContactCard>
        <CloudyContactCard title="Message Whatsapp">
          <div className="flex w-full cursor-not-allowed items-center gap-3 rounded-lg opacity-80">
            <img alt="Whatsapp" className="h-8 w-8" src="/icons/whatsapp.svg" />
            <p className="flex flex-1 text-sm font-medium text-white">
              Envoyer un message via Whatsapp
            </p>
            <span className="rounded-full bg-white/20 px-2 py-1 text-xs font-semibold text-white">
              Bientôt disponible
            </span>
          </div>
        </CloudyContactCard>
      </div>
      <div className="border-gray-light-200 flex flex-col gap-7 rounded-2xl border bg-white p-6">
        <div className="text-gray-light-900 text-lg font-semibold sm:text-2xl">
          Votre agence de voyage
        </div>
        <div className="flex flex-col gap-3">
          <div className="text-sm font-semibold text-gray-900">{locationLabel}</div>
          <div className="text-sm text-gray-900">{openingHours}</div>
          <div className="text-sm text-gray-900">Téléphone : {phone}</div>
        </div>
      </div>
    </div>
  )
}
